/**
 * Node modules
 */
import styled from 'styled-components';

/**
 * Private modules
 */
import { scale } from '../.private';

/**
 * Styled components
 */
export default styled.div`
  align-items: center;
  display: flex;
  font-weight: 600;
  justify-content: center;
  margin-bottom: ${scale.major(2)}px;
  width: 100%;
`;
